<script>
import {DURATIONS, EXPIRY_TIMES, VIEWS} from '../../content/publish/calendar/settings/calendarSettings.js'
export default {
    name: "calendar-tab",
    data() {
        return {
            useCalendar: '0',
        }
    },
    methods: {
        EXPIRY_TIMES() {
            return EXPIRY_TIMES
        },
        VIEWS() {
            return VIEWS
        },
        DURATIONS() {
            return DURATIONS
        }
    },
    computed: {
        translations() {
            return {
                yes: Lang.langGet('Yes'),
                no: Lang.langGet('No'),
                initialView: Lang.langGet('Initial View'),
                timeSlotDuration: Lang.langGet('Time Slot Duration'),
                currentTimeIndicator: Lang.langGet('Show Current Time Indicator'),
                weekNumbers: Lang.langGet('Show Week Numbers'),
                thumbnailInEvent: Lang.langGet('Show Thumbnail In Event'),
                switchOffTimes: Lang.langGet('Show Switch-On Times'),
                expiryTime: Lang.langGet('Expiry Time'),
                expiryTimeHint: Lang.langGet('Defines the cutoff point for published events — any events scheduled before this date will be automatically deleted'),
                subTitle: Lang.langGet('Define the default settings for the calendar. These settings will always be overridden by any user-defined configurations in the calendar.'),
                useCalendar: Lang.langGet('Use Calendar')
            }
        }
    },
    mounted() {
        EaseEventBus.listen('reset-calendar-tab', () => {
            this.useCalendar = '0';
        });
        EaseEventBus.listen('data-calendar-tab', data => {
            this.useCalendar = data.use_calendar_layers?.toString();
        });
    }
}
</script>

<template>
    <div class="column">
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label class="w-100" aria-label="calendar layers select">
                        {{ translations.useCalendar }}
                        <select class="form-control" v-model="useCalendar" name="use_calendar_layers" aria-label="calendar layers select">
                            <option value="1">{{ translations.yes }}</option>
                            <option value="0">{{ translations.no }}</option>
                        </select>
                    </label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label class="w-100" aria-label="calendar expiry time">
                        {{ translations.expiryTime }}
                        <span :data-balloon="translations.expiryTimeHint"
                              data-balloon-pos="below"
                              data-balloon-length="large">
                            <i class="fa-light fa-circle-question cursor-pointer" />
                        </span>
                        <select :disabled="useCalendar !== '1'" class="form-control" name="calendar_expiry_time" aria-label="calendar expiry time select">
                            <option v-for="time in EXPIRY_TIMES()" :value="time.name"> {{ time.translation }}</option>
                        </select>
                    </label>
                </div>
            </div>
        </div>
        <div class="py-8">{{translations.subTitle}}</div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label class="w-100" aria-label="calendar initial view">
                        {{ translations.initialView }}
                        <select :disabled="useCalendar !== '1'" class="form-control" name="calendar_initial_view"
                                aria-label="initial view calendar select">
                            <option v-for="view in VIEWS()" :value="view.name"> {{ view.translation }}</option>
                        </select>
                    </label>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label class="w-100" aria-label="calendar time slot duration">
                        {{ translations.timeSlotDuration }}
                        <select :disabled="useCalendar !== '1'" class="form-control" name="calendar_time_slot_duration"
                                aria-label="time slot duration calendar select">
                            <option v-for="duration in DURATIONS()" :value="duration.name"> {{ duration.translation }}</option>
                        </select>
                    </label>
                </div>
            </div>
            <div class="col-md-4 flex-col">
                <div class="form-group">
                    <label class="w-100" aria-label="calendar current time indicator">
                        {{ translations.currentTimeIndicator }}
                        <select :disabled="useCalendar !== '1'" class="form-control" name="calendar_show_current_time_indicator"
                                aria-label="show current time indicator calendar select">
                            <option value="1">{{ translations.yes }}</option>
                            <option value="0">{{ translations.no }}</option>
                        </select>
                    </label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 flex-col">
                <div class="form-group">
                    <label class="w-100" aria-label="calendar week numbers">
                        {{ translations.weekNumbers }}
                        <select :disabled="useCalendar !== '1'" class="form-control" name="calendar_show_week_numbers" aria-label="show week numbers calendar select">
                            <option value="1">{{ translations.yes }}</option>
                            <option value="0">{{ translations.no }}</option>
                        </select>
                    </label>
                </div>
            </div>
            <div class="col-md-4 flex-col">
                <div class="form-group">
                    <label class="w-100" aria-label="calendar switch off times">
                        {{ translations.switchOffTimes }}
                        <select :disabled="useCalendar !== '1'" class="form-control" name="calendar_show_switch_off_times"
                                aria-label="calendar switch off times select">
                            <option value="1">{{ translations.yes }}</option>
                            <option value="0">{{ translations.no }}</option>
                        </select>
                    </label>
                </div>
            </div>
            <div class="col-md-4 flex-col">
                <div class="form-group">
                    <label class="w-100" aria-label="calendar thumbnail in event">
                        {{ translations.thumbnailInEvent }}
                        <select :disabled="useCalendar !== '1'" class="form-control" name="calendar_show_thumbnail_in_event"
                                aria-label="show thumbnail in event calendar select">
                            <option value="1">{{ translations.yes }}</option>
                            <option value="0">{{ translations.no }}</option>
                        </select>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

